module.exports = __webpack_public_path__ + "img/bus-6.f8e4f8a9.png";